import { uploadProfileImage } from './profile-image-upload'

/**
 * Exposes the {@link uploadProfileImage} operation to the component layer.
 * Components and views must not value-import `model/` directly (the MVVM
 * internal-import rule); this composable is the blessed indirection.
 */
export function useProfileImageUpload() {
  return { uploadProfileImage }
}
